import React, { useEffect, useState } from "react";
import "../../User/styles/pages/home.scss";
import Header from "../../User/layouts/Header";
import Catalogue from "../../User/components/Catalogue";
import Aboutus from "../../User/components/Aboutus";
import Downloadapp from "../../User/components/Download_app";
import Footer from "../../User/layouts/Footer";
import "../styles/pages/home.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination } from "swiper/modules";
import { Typography, Container, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ProceedToWatsapp from "../components/ProceedToWatsapp";
import YesFabricPopup from "../components/YesFabricPopup";
import WhatsApp from "../../User/components/WhatsApp";
import instance from "../../Utils/api";
import consultation from "../assets/consultation.svg";
import cataloguenew from "../assets/catalogueimage.svg";
import upload from "../assets/upload.svg";
import arrowRight from "../assets/arrow.svg";
import StepProgress from "../components/StepProgress";
import Image from "../../Utils/getImage";


const phrases = [
  "Book Your Designer",
  "Explore Our Designs",
  "You Design We Stitch",
];

const repeatedPhrases = [...Array(20)].flatMap(() =>
  phrases.map((text, index) => (
    <span className="scroll-content" key={`${text}-${index}-${Math.random()}`}>
      {text}
      <span className="star"> ✦ </span>
    </span>
  ))
);

const Home = () => {
  const [banners, setBanners] = useState();
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([])

  //Watsapp popup
  const [isWatsapp, setIsWatsapp] = useState(false);
  const handleWatsappOpenModal = () => setIsWatsapp(true);
  const handleWatsappCloseModal = () => setIsWatsapp(false);


  useEffect(() => {
    const getReviews = async () => {
      try {
        const response = await instance.get('Review/Allreviews')
        setReviews(response.data.reviews)
      } catch (err) {
        console.log(err);

      }
    }
    getReviews()
  }, [])

  const [isYesFabric, setIsYesFabric] = useState(false);
  const handleYesFabricOpenModal = () => setIsYesFabric(true);
  const handleYesFabricCloseModal = () => setIsYesFabric(false);
  const [catalogue, setCatalogue] = useState();
  const [swiperKey, setSwiperKey] = useState(0);

  useEffect(() => {
    if (banners?.length) {
      setSwiperKey((prev) => prev + 1);
    }
  }, [banners]);

  const cards = [
    {
      id: 1,
      title: "Book Your Designer",
      description: "Free Personal Stylist",
      description1: "& Fashion Designer Consultation",
      image: consultation,
      onClick: handleWatsappOpenModal,
      background: "#DAE8F6",
    },
    {
      id: 2,
      title: "Explore Our Designs",
      description: "Browse our catalogue and we'll customize to suit your needs",
      image: cataloguenew,
      onClick: () => {
        navigate("/catalogue");
      },
      background: "#F8E6E9",
    },
    {
      id: 3,
      title: "You Design  We Stitch",
      description: "Design your dream outfit?",
      description1: "Upload it, and we’ll stitch it real.",
      image: upload,
      onClick: handleYesFabricOpenModal,
      background: "#FFE6D2",
    },
  ];

  const getBanners = async () => {
    try {
      const response = await instance.get("/Banner/getBanners");
      setBanners(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getCatalogues = async () => {
    try {
      const response = await instance.get("/Catalogue/getDesign");
      setCatalogue(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getCatalogues();
    getBanners();
  }, []);

  return (
    <React.Fragment>
      <Header />
      <section className="catalogue">
        <Swiper
          key={swiperKey}
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Pagination]}
          loop={true}
          pagination={{
            clickable: true,
          }}
        >
          {banners?.length > 0 ? (
            banners
              ?.filter((data) => data?.status === true)
              .map((data, index) => (
                <SwiperSlide key={index}>
                  {data?.image ? (
                    <div className="Banner_images">
                      <Image
                        src={data.image}
                        alt={data?.name || "Banner"}
                        width="100%"
                        height={500}
                      />
                    </div>
                  ) : (
                    <p>No image available</p>
                  )}
                </SwiperSlide>
              ))
          ) : (
            <p>No banners available</p>
          )}
        </Swiper>
      </section>
      <Container>
        <section className="button-section">
          <h4 className="title-home">Let's Design Your Outfit</h4>
          <div className="button-content">
            {cards.map((card, index) => (
              <div
                className="card-home"
                key={index}
                onClick={card.onClick}
                style={{ backgroundColor: card.background }}
              >
                <div className="card-content">
                  <div className="card-inner">
                    <div className="card-left">
                      <img
                        className="arrow-icon"
                        src={arrowRight}
                        alt="arrow"
                      />
                      <div>
                        <Typography
                          className="card-title-new"
                          variant="h5"
                          component="div"
                        >
                          {card.title}
                        </Typography>
                        <Typography
                          className="card-description-new"
                          variant="body2"
                          color="text.secondary"
                        >
                          {card.description}
                        </Typography>
                        <Typography
                          className="card-description-new"
                          variant="body2"
                          color="text.secondary"
                        >
                          {card.description1}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div>
                    <img
                      width={120}
                      height={80}
                      src={card.image}
                      ser={card.title}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </Container>
      <React.Fragment>
        <section className="scrollbar-section">
          <div className="scroll-container">
            <div className="scroll-track">
              {repeatedPhrases}
              {repeatedPhrases}
            </div>
          </div>
        </section>
        <section>
          <StepProgress />
        </section>

        <section className="catalogue-section">
          <div className="Categories-title">
            <div className="categories-title-sub">
              {/* <Typography variant="h4">Catalogue</Typography> */}
              <Typography variant="h5">Explore Our Premium Catalogue</Typography>
            </div>
            <Button onClick={() => navigate("/Categories?name=Catalogue")}>
              View all
            </Button>
          </div>
          <Catalogue data={catalogue} />
        </section>
      </React.Fragment>
      {/* <React.Fragment>
        <Designers data={DesignerData} />
      </React.Fragment> */}
      <React.Fragment>
        <Aboutus data={reviews} />
      </React.Fragment>
      <React.Fragment>
        <Downloadapp />
      </React.Fragment>
      <React.Fragment>
        <Footer />
      </React.Fragment>
      <ProceedToWatsapp
        isWatsapp={isWatsapp}
        handleWatsappCloseModal={handleWatsappCloseModal}
      />
      <YesFabricPopup
        isYesFabric={isYesFabric}
        handleYesFabricCloseModal={handleYesFabricCloseModal}
        add_to_cart={false}
      />
      <WhatsApp />
    </React.Fragment>
  );
};

export default Home;
